var _a;
import { __assign } from "tslib";
import { combineActions, handleActions } from 'redux-actions';
import { publishTier, updateTier, tierSaveError, tierSaveRedirect, } from './actions';
var reducers = handleActions((_a = {},
    _a[combineActions(publishTier, updateTier).toString()] = function (state, action) { return (__assign(__assign({}, state), { requestStatus: 'fetching', errorMessage: undefined })); },
    _a[tierSaveError.toString()] = function (state, action) { return (__assign(__assign({}, state), { requestStatus: 'error', errorMessage: action.payload.message })); },
    _a[tierSaveRedirect.toString()] = function (state, action) { return (__assign(__assign({}, state), { requestStatus: 'redirecting' })); },
    _a), {
    requestStatus: 'idle',
});
export default reducers;
//# sourceMappingURL=tierPopupReducer.js.map